import clsx from 'clsx';
import React, { ForwardedRef, ReactElement, ReactNode } from 'react';
import classes from './Card.module.scss';

export type Props = {
  className?: string;
  children: ReactNode;
} & React.ComponentProps<'section'>;

/**
 * Card component
 * @see https://www.kantardesignlab.io/lp-framework/cards.html
 */
function Card(
  { className, children, ...rest }: Props,
  ref: ForwardedRef<HTMLElement>,
): ReactElement {
  return (
    <section {...rest} className={clsx(classes.root, className)} ref={ref}>
      {children}
    </section>
  );
}

export default React.forwardRef(Card);
